import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Toast } from 'primereact/toast';
import { Box, Button, IconButton, Skeleton, Tooltip, Typography } from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDateformate, useGetBatchHistory } from '../Components/globalFunctions';
import { updateInventoryDetail, updateinventoryDetailsEdit, updateInventoryDetailsModal, updateSelectedBatchNo } from '../Redux/inventory';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import CustomAxios from '../utils/CustomAxios';

export function BatchViewTable() {
    const toast = useRef(null);
    const user_id = useSelector( state => state.user.id)
    const selectedBatch = useSelector(state => state.inventory.selectedBatchNo)
    const searchBatchProduct = useSelector(state => state.inventory.searchBatchProduct)
    const batchHistoryLoading = useSelector(state => state.inventory.batchHistoryLoading)
    const formatdate = useDateformate()
    const getBatchHistory = useGetBatchHistory()
    const dispatch = useDispatch()
    
    const user_role = localStorage.getItem('role');
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    
    const canManageBatch = (batch) => {
        if (user_role === 'super_admin') return true; 
        if (user_role === 'admin') return true; 
        if (user_role === 'supervisor') return true; // enable supervisor edit/delete
        return false; 
    };
    // useEffect(() => {
    //     const filtered = batchHistory.filter((batch) =>
    //         console.log(batch.batch_number,selectedBatchNo) 
    //         // batch.batch_number == selectedBatchNo
    //     )
    //     setSelectedBatch(filtered)
    // }, [selectedBatchNo])
    const handleOpen = (item) => {
        console.log(item)
        dispatch(updateInventoryDetailsModal(true))
        dispatch(updateinventoryDetailsEdit(true));
        dispatch(updateInventoryDetail(item));
        // setErrors({})
    };
    console.log(selectedBatch)
      const confirmDelete = (item) => {
        console.log(item)
        confirmDialog({
          message: (
            <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                Do you want to delete this Batch detail
              </Typography>
            </Box>
          ),
          header: "Delete Confirmation",
          defaultFocus: 'reject',
          acceptClassName: 'p-button-danger',
          accept: () => accept(item),
        });
      };
    
      const accept = async (batch) => {
        try {
          await CustomAxios.delete(`inventory/details/delete/${batch.batch}/`,{data:{admin_id:user_id,batch_details_id:batch.id,batch_delete:false}})
          .then(() => {
            getBatchHistory()
            dispatch(updateSelectedBatchNo({}))
            toast.current.show({
                  severity: "success",
                  summary: "Success",
                  detail: "Batch details deleted successfully",
                  life: 3000,
                });
          })
                
        } catch (err) {
          console.error("Error deleting delivery details", err);
        }
      };
      console.log(selectedBatch)
    return (<Box>
        {/* <ConfirmDialog/> */}
        <Toast ref={toast} />
        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S no</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Product Name</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Batch</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Quantity</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Purchased On</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Expired on</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Actions</TableCell>


                    </TableRow>
                </TableHead>
                <TableBody>
                    {selectedBatch?.batch?.length > 0 ?
                        selectedBatch?.batch.filter((item) => {
                            if (!item.product.item_name) return false;
                        
                            return searchBatchProduct !== ""
                              ? item.product.item_name.toLowerCase().includes(searchBatchProduct?.toLowerCase())
                              : true; }).map((item, ind) => {
                            // console.log(item)
                            return (<> {
                                <TableRow key={item.batch}>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{ind + 1}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.product.item_name}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{selectedBatch.batch_number}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.quantity}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{formatdate(selectedBatch.purchased_on)}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{formatdate(item.expired_on)}</TableCell>
                                    {/* <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>---</TableCell> */}
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white", display: "flex", gap: "8px", alignItems: "center" }}>
                                        {(() => {
                                            const canManage = canManageBatch(selectedBatch);
                                            
                                            if (user_role === 'super_admin') {
                                                // Super Admin: Can edit and delete all batches
                                                return (
                                                    <>
                                                        <Tooltip title="Update" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(selectedBatch)}> 
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}>Edit</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip title="Delete" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}> 
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}>Delete</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    </>
                                                );
                                            } else if (user_role === 'admin') {
                                                // Admin: Can edit and delete only assigned hub batches
                                                if (canManage) {
                                                    return (
                                                        <>
                                                            <Tooltip title="Update" arrow>
                                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(selectedBatch)}> 
                                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}>Edit</Typography>
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="Delete" arrow>
                                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}> 
                                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}>Delete</Typography>
                                                                </Button>
                                                            </Tooltip>
                                                        </>
                                                    );
                                                } else {
                                                    return (
                                                        <>
                                                            <Tooltip title="View Only - Not assigned to this hub" arrow>
                                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "gray", border: "1px solid", borderColor: "gray", opacity: 0.5 }} disabled> 
                                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "white" }}>Edit</Typography>
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="View Only - Not assigned to this hub" arrow>
                                                                <Button sx={{ width: "38px", height: "22px", backgroundColor: "gray", border: "1px solid", borderColor: "gray", opacity: 0.5 }} disabled> 
                                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "white" }}>Delete</Typography>
                                                                </Button>
                                                            </Tooltip>
                                                        </>
                                                    );
                                                }
                                            } else if (user_role === 'supervisor') {
                                                // Supervisor: Now can edit and delete batches
                                                return (
                                                    <>
                                                        <Tooltip title="Update" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(selectedBatch)}> 
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}>Edit</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip title="Delete" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}> 
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}>Delete</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    </>
                                                );
                                            } else {
                                                // Other roles: No access
                                                return (
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "gray" }}>
                                                        No Access
                                                    </Typography>
                                                );
                                            }
                                        })()}
                                    </TableCell>
                                </TableRow>}</>)
                        })
                        : <TableRow  >
                            
                                <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }} colSpan={7}>No Batch Selected</TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}